/*jshint esversion: 6 */

import Tooltip from "@ryangjchandler/alpine-tooltip";

/// For the tooltip
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/scale.css';
import 'tippy.js/themes/light.css';

// ponytail: nao importa nem inicia uma copia propria do Alpine ("import Alpine
// from 'alpinejs'" + Alpine.start()) -- o Livewire ja traz o proprio Alpine
// embutido, assume window.Alpine e chama .start() nele sozinho (ver
// vendor/livewire/livewire/dist/livewire.js). Ter as duas gera "Detected
// multiple instances of Alpine running": plugins/diretivas registrados na
// copia propria nunca existem na instancia que o Livewire realmente inicia,
// entao qualquer x-data/x-html que dependa deles (ex: pgRenderActions/toHtml
// do PowerGrid) quebra com "is not defined" -- piorou muito com wire:navigate,
// que reinicializa o DOM a cada navegacao (mais chances da corrida dar
// errado) em vez de só uma vez por reload completo.
//
// Tambem NAO importa mais @alpinejs/focus, /collapse, /mask, /persist,
// /anchor: conferido direto no bundle do Livewire
// (vendor/livewire/livewire/dist/livewire.js) que ele ja embute os 5 —
// Alpine3.directive("collapse"/"trap"/"intersect"/"anchor"/"mask") e
// Object.defineProperty(Alpine3, "$persist", ...) já existem lá dentro.
// Registrar nossa própria cópia de novo por cima quebrava com
// "Cannot redefine property: $persist" (persist usa Object.defineProperty
// sem configurable:true, então uma segunda chamada de Alpine.plugin(persist)
// trava o Alpine.start() inteiro). @ryangjchandler/alpine-tooltip é o único
// plugin de verdade que não vem embutido.
//
// Fix: registrar tudo no evento alpine:init, que é disparado pelo próprio
// Alpine (dentro do Livewire) exatamente antes de escanear o DOM. Scripts
// type="module" sempre terminam de rodar antes do DOMContentLoaded, e o
// Livewire só chama seu Alpine.start() DEPOIS do DOMContentLoaded — então
// este listener sempre está registrado a tempo, não importa a ordem relativa
// entre este módulo e o <livewire:scripts/>.
document.addEventListener('alpine:init', () => {
    "use strict";

    const Alpine = window.Alpine;

    Alpine.plugin(Tooltip.defaultProps({
        theme: 'light',
    }));

    // O projeto usa `x-tooltip.theme.light` (sem valor) ao lado de `x-tooltip.raw="..."` em dezenas de
    // views. O tema light já é o padrão acima, e a diretiva vazia passou a ser avaliada como expressão
    // vazia pelo Alpine atual (SyntaxError "Unexpected token '}'"). Descartada antes de ser avaliada.
    Alpine.interceptInit((el) => {
        for (const attr of Array.from(el.attributes ?? [])) {
            if (attr.name.startsWith('x-tooltip') && attr.value === '') {
                el.removeAttribute(attr.name);
            }
        }
    });

    Alpine.magic("money", () => (subject) => {
        return (
            "R$ " +
            subject
                .toFixed(2)
                .replace(".", ",")
                .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
        );
    });

    Alpine.directive("button-href", (el, {expression, modifiers}, {evaluate}) => {
        if (el.tagName !== "BUTTON" || expression === '' || window.location.href === expression) {
            console.log('Invalid button-href directive.');
            return;
        }
        el.addEventListener("click", () => {
            el.setAttribute("disabled", true);
            el.classList.add("cursor-not-allowed", "opacity-75");

            // Spinner como nó próprio (não reescrevendo o innerHTML) para poder ser
            // removido no failsafe; antes ele ficava no botão para sempre.
            let spinner = null;
            if (!el.getElementsByTagName("svg").length) {
                spinner = document.createElement("span");
                spinner.innerHTML =
                    '<svg class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">' +
                    '<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>' +
                    '<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>' +
                    "</svg>";
                el.prepend(spinner);
            }

            setTimeout(() => {
                el.removeAttribute("disabled");
                el.classList.remove("cursor-not-allowed", "opacity-75");
                spinner?.remove();
            }, 5000);

            // .native: navegação completa (redirects externos, ex.: OAuth do Google, não funcionam via wire:navigate/fetch).
            if (modifiers.includes("native")) {
                window.location.href = expression;
                return;
            }

            Livewire.navigate(expression);
        });
    });

    // Registra a diretiva x-img-retry
    Alpine.directive('img-retry', (el, {expression}, {evaluate}) => {
        // Garante que a diretiva só seja aplicada em tags <img>
        if (el.tagName.toLowerCase() !== 'img') {
            return;
        }

        // Base64 do SVG de fallback
        const fallbackBase64 = 'data:image/svg+xml,%3Csvg%20width%3D%22965.82%22%20height%3D%221122.52%22%20viewBox%3D%220%200%20965.82%201122.52%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cdefs%3E%3ClinearGradient%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%221%22%20y2%3D%220%22%20gradientUnits%3D%22userSpaceOnUse%22%20gradientTransform%3D%22rotate(-60%20886.77%20-457.98)scale(180.17876)%22%20spreadMethod%3D%22pad%22%20id%3D%22b%22%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23bb551c%22%20offset%3D%220%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23fab24a%22%20offset%3D%22.309%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23fab24a%22%20offset%3D%22.6%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23fab24a%22%20offset%3D%22.891%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23fab24a%22%20offset%3D%221%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%221%22%20y2%3D%220%22%20gradientUnits%3D%22userSpaceOnUse%22%20gradientTransform%3D%22rotate(-45%201312.235%20-442.04)scale(308.84108)%22%20spreadMethod%3D%22pad%22%20id%3D%22c%22%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23ec4146%22%20offset%3D%220%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23ec4146%22%20offset%3D%22.337%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23ec4146%22%20offset%3D%22.722%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23a31e25%22%20offset%3D%22.995%22%2F%3E%3Cstop%20style%3D%22stop-opacity%3A1%3Bstop-color%3A%23a31e25%22%20offset%3D%221%22%2F%3E%3C%2FlinearGradient%3E%3CclipPath%20clipPathUnits%3D%22userSpaceOnUse%22%20id%3D%22a%22%3E%3Cpath%20d%3D%22M-342.763%20402.777h1190.55v-841.89h-1190.55Z%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3Cpath%20d%3D%22M0%200c2.317-4.548.492-10.166-4.056-12.483l-66.157-33.709c-4.548-2.317-10.165-.492-12.483%204.057l-33.708%2066.156c-2.318%204.548-.492%2010.166%204.056%2012.483l66.156%2033.708c4.549%202.318%2010.166.493%2012.484-4.055z%22%20style%3D%22fill%3A%23f57861%3Bfill-opacity%3A1%3Bfill-rule%3Anonzero%3Bstroke%3Anone%22%20transform%3D%22matrix(1.33333%200%200%20-1.33333%20457.016%20537.036)%22%20clip-path%3D%22url(%23a)%22%2F%3E%3Cpath%20d%3D%22m905.692%20375.341-88.208%2044.944c-6.065%203.09-8.499%2010.58-5.408%2016.644l44.944%2088.21v23.66h5.515c0-8.956%205.825-15.551%2011.129-18.252l88.21-44.946c6.063-3.089%208.497-10.58%205.407-16.644l-44.945-88.209c-2.18-4.277-6.548-6.748-11.063-6.748-1.884%200-3.794.43-5.581%201.341%22%20style%3D%22fill%3Aurl(%23b)%3Bstroke%3Anone%3Bstroke-width%3A1.33333%22%20transform%3D%22translate(-280.531%20-48.96)%22%2F%3E%3Cpath%20d%3D%22m853.541%20518.31-.032-.063zm1.099%2014.836c-2.501%207.744-7.887%2011.12-10.337%2012.368-2.451%201.25-95.023%2048.408-99.427%2050.652-4.404%202.246-5.988%206.003-5.988%209.363v230.61c0%203.46%201.748%206.546%204.368%208.426%203.065%202.2%207.407%202.393%2010.23.956l103.626-52.8s5.525-2.585%205.525-9.135c0-1.966-.042-222.72-.042-237.678%200-4.332-.526-7.6-1.45-11.035-1.233-4.583-3.048-7.577-4.05-9.59a863%20863%200%200%200-3.554-6.973c.359.711%203.527%207.319%201.099%2014.836%22%20style%3D%22fill%3Aurl(%23c)%3Bstroke%3Anone%3Bstroke-width%3A1.33333%22%20transform%3D%22translate(-280.531%20-48.96)%22%2F%3E%3C%2Fsvg%3E';

        // Permite definir o número de tentativas via parâmetro (ex: x-img-retry="5"). O padrão é 3.
        const maxRetries = expression ? evaluate(expression) : 3;
        let retries = 0;

        const handleError = () => {
            // Trava de segurança para não tentar recarregar o próprio base64
            if (el.src.startsWith('data:image')) {
                return;
            }

            if (retries < maxRetries) {
                retries++;

                setTimeout(() => {
                    try {
                        const url = new URL(el.src, window.location.origin);
                        url.searchParams.set('retry', new Date().getTime());
                        el.src = url.toString();
                    } catch (e) {
                        el.src = fallbackBase64;
                    }
                }, 1000);
            } else {
                // Falhou todas as vezes, aplica o fallback e remove o listener para limpar a memória
                console.warn(`Imagem falhou após ${maxRetries} tentativas. Aplicando fallback:`, el.src);
                el.src = fallbackBase64;
                el.removeEventListener('error', handleError);
            }
        };

        // Escuta o evento de erro especificamente neste elemento
        el.addEventListener('error', handleError);
    });
});
